/**
 * Tijd (TIJD) — 16 families, 3 skills
 *
 * Skills: klokkijken (6), tijdrekenen (7), snelheid (3)
 *
 * Created as part of Fase 0 TGL Split (17 maart 2026).
 * Split from TGL.ts — TIJD families only.
 *
 * familyIds normalized: TIJD-* (T8 Phase 2, april 2026).
 */

import type { FamilyDefinition } from '../types'

export const TIJD_FAMILIES: FamilyDefinition[] = [
  // 1. Skill: klokkijken (6 families)
  {
    familyId: 'TIJD-ANALOOG',
    module: 'Tijd',
    skill: 'klokkijken',
    subSkill: 'klok_analoog',
    tier: 1,
    levelCode: 'B6',
    description: 'Analoge klok (kwartieren)',
  },
  {
    familyId: 'TIJD-DIGITAAL',
    module: 'Tijd',
    skill: 'klokkijken',
    subSkill: 'klok_digitaal',
    tier: 3,
    levelCode: 'M6',
    description: 'Digitale klok (24-uurs)',
  },
  {
    familyId: 'TIJD-ANALOOG-GEDETAILLEERD',
    module: 'Tijd',
    skill: 'klokkijken',
    subSkill: 'klok_analoog_gedetailleerd',
    tier: 3,
    levelCode: 'M6',
    description: 'Analoog 5-min precisie',
  },
  {
    familyId: 'TIJD-CONVERSIE',
    module: 'Tijd',
    skill: 'klokkijken',
    subSkill: 'klok_conversie',
    tier: 5,
    levelCode: 'E6',
    description: 'Analoog ↔ Digitaal',
  },
  {
    familyId: 'TIJD-12-24',
    module: 'Tijd',
    skill: 'klokkijken',
    subSkill: 'klok_12_24_notatie',
    tier: 7,
    levelCode: 'B7',
    description: '12-uurs ↔ 24-uurs notatie',
  },
  {
    familyId: 'TIJD-TIJDZONES',
    module: 'Tijd',
    skill: 'klokkijken',
    subSkill: 'klok_tijdzones',
    tier: 13,
    levelCode: 'B8',
    description: 'Tijdzones en wereldtijd',
  },
  // 2. Skill: tijdrekenen (7 families)
  {
    familyId: 'TIJD-DUUR',
    module: 'Tijd',
    skill: 'tijdrekenen',
    subSkill: 'tijd_duur_berekenen',
    tier: 7,
    levelCode: 'B7',
    description: 'Tijdsduur berekenen',
  },
  {
    familyId: 'TIJD-SAMENGESTELD',
    module: 'Tijd',
    skill: 'tijdrekenen',
    subSkill: 'tijd_samengesteld',
    tier: 8,
    levelCode: 'B7+',
    description:
      'Samengestelde tijdberekeningen: eindtijd, duur, totale werktijd',
  },
  {
    familyId: 'TIJD-PLANNING',
    module: 'Tijd',
    skill: 'tijdrekenen',
    subSkill: 'tijd_planning',
    tier: 9,
    levelCode: 'M7',
    description: 'Tijd plannen met context',
  },
  {
    familyId: 'TIJD-SCHEMA',
    module: 'Tijd',
    skill: 'tijdrekenen',
    subSkill: 'tijd_schema_lezen',
    tier: 11,
    levelCode: 'E7',
    description: "Schema's en roosters lezen",
  },
  {
    familyId: 'TIJD-KALENDER',
    module: 'Tijd',
    skill: 'tijdrekenen',
    subSkill: 'tijd_kalender',
    tier: 11,
    levelCode: 'E7',
    description: 'Kalenderberekeningen',
  },
  {
    familyId: 'TIJD-OMREKENEN',
    module: 'Tijd',
    skill: 'tijdrekenen',
    subSkill: 'tijd_omrekenen',
    tier: 11,
    levelCode: 'E7',
    description: 'Tijdseenheden omrekenen',
  },
  {
    familyId: 'TIJD-DIAGRAM',
    module: 'Tijd',
    skill: 'tijdrekenen',
    subSkill: 'tijd_diagram',
    tier: 12,
    levelCode: 'E7+',
    description: 'Tijddiagrammen interpreteren (CITO)',
  },
  // 3. Skill: snelheid (3 families)
  {
    familyId: 'TIJD-SNELHEID',
    module: 'Tijd',
    skill: 'snelheid',
    subSkill: 'snelheid_berekenen',
    tier: 13,
    levelCode: 'B8',
    description: 'Snelheid berekenen (AST)',
  },
  {
    familyId: 'TIJD-AFSTAND',
    module: 'Tijd',
    skill: 'snelheid',
    subSkill: 'afstand_berekenen',
    tier: 14,
    levelCode: 'M8',
    description: 'Afstand berekenen uit snelheid',
  },
  {
    familyId: 'TIJD-GEMIDDELDE',
    module: 'Tijd',
    skill: 'snelheid',
    subSkill: 'snelheid_gemiddelde',
    tier: 15,
    levelCode: 'E8',
    description: 'Gemiddelde snelheid',
  },
]
